import type { VariantProps } from 'class-variance-authority';

import type { buttonVariants } from '@/components/ui/button';

type ButtonVariant = NonNullable<VariantProps<typeof buttonVariants>['variant']>;

/**
 * What an action does decides its WFP button variant.
 * - `primary` — the main action of a screen or dialog (Save, Submit, Apply)
 * - `action` — routine actions (Edit, Change status, Add)
 * - `document` — uploading, generating, printing, exporting or downloading documents and data
 * - `view` — views and filters (Filters, Viewpoint, Columns, Fullscreen, History)
 * - `dismiss` — leaving without changes (Cancel, Close, Reset)
 * - `danger` — destructive actions (Delete, Remove, Cancel consignment)
 * - `danger-confirm` — the confirming button of a destructive dialog
 */
export const INTENT_VARIANT = {
  primary: 'default',
  action: 'secondary',
  document: 'success-secondary',
  view: 'outline',
  dismiss: 'outline',
  danger: 'destructive-secondary',
  'danger-confirm': 'destructive'
} as const satisfies Record<string, ButtonVariant>;

export type ActionIntent = keyof typeof INTENT_VARIANT;
